import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import { Alert, Loading } from '@/components/common/State';

/** 백엔드 OAuth2SuccessHandler 가 토큰을 쿼리로 실어 여기로 리다이렉트한다. */
export default function OAuthCallbackPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const loginWithTokens = useAuthStore((s) => s.loginWithTokens);
  const [error, setError] = useState<string | null>(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    if (searchParams.get('error')) {
      setError('소셜 로그인에 실패했습니다. 다시 시도해 주세요.');
      return;
    }

    const accessToken = searchParams.get('accessToken');
    const refreshToken = searchParams.get('refreshToken');
    if (!accessToken || !refreshToken) {
      setError('토큰을 받지 못했습니다.');
      return;
    }

    loginWithTokens(decodeURIComponent(accessToken), decodeURIComponent(refreshToken))
      .then(() => navigate('/', { replace: true }))
      .catch((e: Error) => setError(e.message));
  }, [searchParams, loginWithTokens, navigate]);

  if (error) {
    return (
      <div className="state">
        <Alert tone="error">{error}</Alert>
        <button type="button" className="btn btn--primary btn--sm" onClick={() => navigate('/login')}>
          로그인 화면으로
        </button>
      </div>
    );
  }

  return <Loading label="로그인 처리 중입니다…" />;
}
